module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("PUBLISHER:")]), _vm._v(" Amy Marson")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("CREATIVE DIRECTOR:")]), _vm._v(" Gailen Runge")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("ACQUISITIONS EDITOR:")]), _vm._v(" Roxane Cerda")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("MANAGING EDITOR:")]), _vm._v(" Liz Aneloski")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("EDITORS:")]), _vm._v(" Liz Aneloski and Katie Van Amburg")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("TECHNICAL EDITOR:")]), _vm._v(" Helen Frost")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("COVER/BOOK DESIGNER:")]), _vm._v(" April Mostek")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("PRODUCTION COORDINATOR:")]), _vm._v(" Tim Manibusan")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("PRODUCTION EDITOR:")]), _vm._v(" Alice Mace Nakanishi")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("ILLUSTRATOR:")]), _vm._v(" Mary E. Flynn")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("PHOTO ASSISTANT:")]), _vm._v(" Mai Yong Vang")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("COVER AND STYLE PHOTOGRAPHY")]), _vm._v(" by Lucy Glover and "), _c('br'), _c('b', [_vm._v("INSTRUCTIONAL PHOTOGRAPHY")]), _vm._v(" by Mai Yong Vang of C&T Publishing, Inc., unless otherwise noted")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Published by C&T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg2-1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-121c5246","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_Copyright.vue
// module id = 60
// module chunks = 0